import React, { useState } from 'react';
import { Theme, Footer, MainContainer, CookieBanner } from 'ktr-materialui-react';
import { ThemeProvider } from '@material-ui/core/styles';
import { CssBaseline } from '@material-ui/core';
import Header from './components/Header';
import { HashRouter as Router } from 'react-router-dom';
import { IntlProvider } from 'react-intl';
import { Translations } from './react-intl/Translations';
import { LanguageProvider } from './react-intl/LanguageContext';
import Navigation from './components/Navigation';
import Start from './steps/Start';

function App() {

  let resolvedLang = navigator.language.split(/[-_]/)[0];

  if(resolvedLang.includes('de') || resolvedLang.includes('en')) {
      resolvedLang = navigator.language.split(/[-_]/)[0].toString();
  } else {
      resolvedLang = 'en';
  }
 
  const [language,setLanguage] = useState(resolvedLang);


  function changeLanguage(langCode:string) {
    setLanguage(langCode);
  }

  const currentLanguage = Translations.filter(lang => lang.langcode === language)[0];


  return (
    <LanguageProvider.Provider value={{language, changeLanguage}}>
      <IntlProvider locale={currentLanguage.langcode} messages={currentLanguage.locale}>
        <React.Fragment>
          <Router>
          <CookieBanner.default 
            language={currentLanguage.langcode}
            googleAnalytics={
              {
                googleAnalytics: true, //turn google analytics integration on
                googleAnalyticsPagePath: "/clampexassistant"  //set the googleAnalytics Path. (Path of your application) Important!!
                  } as CookieBanner.AnalyticsSettings
              } //
            salesViewer={true} //if you want to integrate salesviewer
            >
              
            </CookieBanner.default>
            <CssBaseline /> {/* this will set default material ui css settings e.g. 0px margin to every browser on body */}
            <ThemeProvider theme={Theme.whiteKTRTheme}>
              <Header/>
              <Navigation/>
              <MainContainer>
               <Start/>
              </MainContainer>
              <Footer language={currentLanguage.langcode} />
            </ThemeProvider>
          </Router>
        </React.Fragment >
      </IntlProvider>
    </LanguageProvider.Provider>
  );
}

export default App;
